import React, { useLayoutEffect, useRef, useState } from 'react';
import { getSiteViewportWidth } from './siteTokens';

// Renders the site at the full-screen editor width, then scales it down to
// fit its container — Squarespace-style thumbnail of the real page, so the
// preview wraps text and lays out sections exactly like Edit mode.
export function ScaledSiteFrame({ children, testid = 'scaled-site-frame' }) {
  const outerRef = useRef(null);
  const innerRef = useRef(null);
  const [m, setM] = useState({ w: getSiteViewportWidth(), scale: 1, h: 0 });

  useLayoutEffect(() => {
    const outer = outerRef.current;
    const inner = innerRef.current;
    if (!outer || !inner) return undefined;
    const update = () => {
      const w = getSiteViewportWidth();
      const scale = Math.min(1, outer.clientWidth / w);
      const h = inner.offsetHeight;
      setM((prev) => (prev.w === w && prev.scale === scale && prev.h === h ? prev : { w, scale, h }));
    };
    update();
    const ro = new ResizeObserver(update);
    ro.observe(outer);
    ro.observe(inner);
    window.addEventListener('resize', update);
    return () => { ro.disconnect(); window.removeEventListener('resize', update); };
  }, []);

  return (
    <div ref={outerRef} className="relative overflow-hidden" style={{ height: m.h * m.scale }} data-testid={testid} data-scale={m.scale}>
      <div ref={innerRef} style={{ width: m.w, transform: `scale(${m.scale})`, transformOrigin: 'top left' }}>
        {children}
      </div>
    </div>
  );
}

export default ScaledSiteFrame;
